import { render, staticRenderFns } from "./ChatbotStyleEditor.vue?vue&type=template&id=b670f0b8&scoped=true&"
import script from "./ChatbotStyleEditor.vue?vue&type=script&lang=ts&"
export * from "./ChatbotStyleEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ChatbotStyleEditor.vue?vue&type=style&index=0&id=b670f0b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b670f0b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VCol,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels})
